import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { ExpeditionStatusEnum } from '@api/ringil-api.v2';
import styled from 'styled-components';

interface ComponentProps {
  expeditionStage: ExpeditionStatusEnum | string; // Allow string for flexibility, though enum is preferred
  isManual: boolean;
}

interface StatusTagProps {
  textColor: string;
  borderColor: string;
  bgColor?: string; // Optional background color
}

const StatusTag = styled.span<StatusTagProps>`
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 0.25rem; // 4px
  border: 1px solid ${props => props.borderColor};
  color: ${props => props.textColor};
  background-color: ${props => props.bgColor || 'transparent'};
  font-size: 0.875rem; // 14px
  font-weight: 500; // Medium weight
  line-height: 1.2;
  text-align: center;
  white-space: nowrap;
`;

const ExpeditionStateSpan: React.FC<ComponentProps> = ({ expeditionStage, isManual }) => {
  const { tr } = useTranslationLgs();

  let textColor = '#6B7280'; // Default: gray-500
  let borderColor = '#D1D5DB'; // Default: gray-300
  const bgColor = 'transparent';

  // Colors based on the provided image
  const purpleColor = '#8B5CF6'; // approx Viola
  const lightBlueColor = '#38BDF8'; // approx Sky
  const greenColor = '#22C55E'; // approx Green
  const greyColor = '#9CA3AF'; // approx Cool Gray 400 for text, Cool Gray 300 for border

  switch (expeditionStage) {
    case ExpeditionStatusEnum.NEW:
      textColor = purpleColor;
      borderColor = purpleColor;
      break;
    case ExpeditionStatusEnum.ASSIGNING:
      textColor = lightBlueColor;
      borderColor = lightBlueColor;
      break;
    case ExpeditionStatusEnum.ASSIGNED:
      textColor = greenColor;
      borderColor = greenColor;
      break;
    case ExpeditionStatusEnum.READY_TO_SHIPMENT:
      textColor = greenColor;
      borderColor = greenColor;
      break;
    case ExpeditionStatusEnum.ACTIVE:
      textColor = greenColor;
      borderColor = greenColor;
      break;
    case ExpeditionStatusEnum.WAITING_FOR_DOCS:
      textColor = lightBlueColor;
      borderColor = lightBlueColor;
      break;
    case ExpeditionStatusEnum.FINISHED:
      textColor = greyColor;
      borderColor = '#D1D5DB'; // Lighter grey for border
      break;
    case ExpeditionStatusEnum.CANCELED:
      textColor = greyColor;
      borderColor = '#D1D5DB'; // Lighter grey for border
      break;
    default:
      // Keep default grey for any other statuses
      break;
  }

  return (
    <StatusTag textColor={textColor} borderColor={borderColor} bgColor={bgColor} title={tr(`StateTooltip${expeditionStage}`, `${expeditionStage}`)}>
      {tr(`Shipments.${expeditionStage}`, `${expeditionStage}`)}
    </StatusTag>
  );
};

export default ExpeditionStateSpan;
